// Retired management page: keep old bookmarks useful without exposing a second directory.
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_settings/settings/service-accounts')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/members', replace: true });
  },
});
